/* Shared card rail for the bc-* sections.
 *
 * Every section that uses snippets/bc-carousel.liquid loads this file, so the
 * script may execute more than once on a page. Each instance is stamped once
 * and skipped afterwards, which also makes it safe to re-run on the theme
 * editor's shopify:section:load.
 *
 * When the cards already fit the viewport there is nothing to scroll, so the
 * rail marks itself .is-static and the arrows and dots disappear rather than
 * sitting there inert.
 */
(function () {
  function init(root) {
    if (root.dataset.bcCarReady === '1') return;
    root.dataset.bcCarReady = '1';

    var track = root.querySelector('[data-bc-car-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bc-car-dots] button'));
    var prev = root.querySelector('[data-bc-car-prev]');
    var next = root.querySelector('[data-bc-car-next]');

    function step() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    /* one arrow press = a full viewport of cards, never less than one card */
    function delta() {
      var s = step();
      if (!s) return 0;
      return s * Math.max(1, Math.floor((track.clientWidth + 2) / s));
    }

    function sync() {
      var s = step();
      var i = s ? Math.round(track.scrollLeft / s) : 0;
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });

      var scrollable = track.scrollWidth - track.clientWidth > 4;
      root.classList.toggle('is-static', !scrollable);
      if (prev) prev.disabled = !scrollable || track.scrollLeft <= 4;
      if (next) next.disabled = !scrollable || track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -delta(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: delta(), behavior: 'smooth' }); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.dataset.index, 10) || 0;
        track.scrollTo({ left: step() * i, behavior: 'smooth' });
      });
    });

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 70); }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }
    sync();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bc-car]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
}());
